import axios from "axios";
import React, { useState } from "react";
import './QueryForm.css'
const QueryForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = { name, email, query };

    try {
      const response = await axios.post("/api/query/send-query", formData);

      if (response.data.querySent) {
        setStatus({ success: true, message: "Query sent successfully!" });
        setName("");
        setEmail("");
        setQuery("");
      } else if (!response.data.querySent) {
        setStatus({ success: false, message: response.error || "Failed to send query." });
      }
    } catch (error) {
      setStatus({ success: false, message: "Server error. Please try again later." });
    }
  };

  return (
    <div className="query-form">
      <h2>Send Your Query</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" placeholder="Your Name" value={name} onChange={(e) => setName(e.target.value)} required />
        <input type="email" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <textarea placeholder="Your Query" value={query} onChange={(e) => setQuery(e.target.value)} required />
        <button type="submit">Submit</button>
      </form>
      {status && <p className={status.success ? "success" : "error"}>{status.message}</p>}
    </div>
  );
};

export default QueryForm;
